var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout" }, [
    _c(
      "div",
      {
        staticClass: "md-layout-item md-size-100",
        class: _vm.disableFilter ? "" : "ontop",
      },
      [
        _c(
          "md-card",
          [
            _c(
              "md-card-content",
              [
                _c(
                  "collapse",
                  {
                    class: _vm.disableFilter
                      ? "collapse-panel-zindex"
                      : "collapse-panel",
                    attrs: {
                      collapse: ["Filters"],
                      icon: "keyboard_arrow_down",
                      "color-collapse": !_vm.disableFilter ? "success" : "",
                      disabled: _vm.disableFilter,
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "md-collapse-pane-1" },
                      [
                        _c("process-charge-overview-toolbar", {
                          attrs: {
                            "team-region-id": _vm.user.teamRegionId,
                            "is-cost-approval-feature-enabled":
                              _vm.isCostApprovalFeatureEnabled,
                            "is-charge-approval-feature-enabled":
                              _vm.isChargeApprovalFeatureEnabled,
                            "service-packages": _vm.servicePackages,
                            "active-tab": _vm.activeTab,
                          },
                          on: {
                            onFilterProcessCharges: _vm.handleFilterChanged,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
      },
      [
        _c(
          "md-card",
          { staticClass: "custom-card" },
          [
            _c(
              "tabs",
              {
                staticClass: "custom-tab-list",
                attrs: {
                  "tab-name": _vm.tabNames,
                  "color-button": "success",
                  "selected-panel":
                    _vm.replaceDashToSpacesAndCapitalizeFirstLetter(
                      _vm.activeTab
                    ),
                },
                on: { "switch-panel": _vm.switchTab },
              },
              [
                _vm._l(_vm.tabNames, function (tabName, index) {
                  return _c("template", { slot: "tab-pane-" + (index + 1) }, [
                    _c(
                      "div",
                      {
                        key: tabName,
                        staticClass: "pull-right review-contents",
                      },
                      [
                        _c(_vm.tabComponents[index], {
                          ref: "processChargeTab",
                          refInFor: true,
                          tag: "component",
                          staticClass: "review-contents",
                          attrs: {
                            filter: _vm.filters,
                            "service-packages": _vm.servicePackages,
                          },
                          on: {
                            totalCostDropDownUpdated:
                              _vm.updateTotalCostDropDown,
                            totalChargeDropDownUpdated:
                              _vm.updateTotalChargeDropDown,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                }),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }